import React from 'react';
import { SkeletonItem } from '@atlaskit/menu';
import { Box } from '@atlaskit/primitives';

export const ListFallback = (): React.JSX.Element => (
	<Box>
		<SkeletonItem hasIcon isShimmering />
		<SkeletonItem hasIcon isShimmering />
		<SkeletonItem hasIcon isShimmering />
		<SkeletonItem hasIcon isShimmering />
		<SkeletonItem hasIcon isShimmering />
		<SkeletonItem isShimmering width="120px" />
	</Box>
);
